import React from 'react';

const ChartCard = ({ title, type }) => {
  return (
    <div className="chart-card">
      <h3>{title}</h3>

      {type === 'line' ? (
        <div className="fake-line-chart">
          <div className="line-shape"></div>
        </div>
      ) : (
        <div className="bar-chart">
          {[240, 220, 310, 280, 390, 350].map((height, index) => (
            <div key={index} style={{ height: `${height / 4}px` }}></div>
          ))}
        </div>
      )}

      <div className="chart-months">
        <span>Jan</span>
        <span>Feb</span>
        <span>Mar</span>
        <span>Apr</span>
        <span>May</span>
        <span>Jun</span>
      </div>
    </div>
  );
};

export default ChartCard;